export default "__VITE_ASSET__CKOMlgEV__"